package com.appsyde.shared.modules.ticket.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class TicketsResponseDto(
    val tickets: List<TicketDto>
)

@Serializable
data class TicketDto(
    val id: String,
    val threadId: String,
    val status: String,
    val statusSource: String = "AUTO",
    val needsResponse: Boolean,
    val isRead: Boolean = true,

    val clientEmail: String? = null,
    val subject: String? = null,

    val stateSummary: String?,
    val respondContext: String?,
    val detectedMemoryJson: String?,
    val missingKeysJson: String,
    val toConfirmKeysJson: String,
    val currentIntent: String?,
    val currentPriority: String?,
    val currentComplexity: String?,
    val currentSuggestedActionCode: String?,
    val currentSuggestedActionLabel: String?,
    val updatedAtMs: Long,
    val lastInboundMessageId: String?,
    val lastInboundSentAtMs: Long? = null,
    val lastOutboundSentAtMs: Long? = null,

    /** AI extract status for last inbound: READY, RUNNING, PENDING, ERROR, or null. */
    val extractStatus: String? = null,
    /** When extractStatus == READY, extract JSON for row title. */
    val extractJson: String? = null,

    val assignedTo: AssignedToDto? = null,
    val writeLock: WriteLockDto? = null
)

@Serializable
data class AssignedToDto(
    val accountUserId: String,
    val displayName: String
)

@Serializable
data class WriteLockDto(
    val accountUserId: String,
    val displayName: String,
    val expiresAt: String
)
